import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_API_BASE_URL
const businessType = localStorage?.getItem('businessType');

export const requestVehicleApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page+1 : 1
  let url = `${env}${API_ENDPOINT.AssignVehicle.requestVehicleApi + '?type=' + data?.type+"&page="+page+"&pageSize="+data?.pageSize}&${businessType}=true`
  const res = await requestInstance.get(
    url
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}
export const listAssignedVehicleApi = async (id) => {
  let url = `${env}${API_ENDPOINT.AssignVehicle.listAssignedVehicleApi}?${businessType}=true`
  const res = await requestInstance.get(
    url
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}
export const assignVehicleApi = async (id) => {
  let url = `${env}${API_ENDPOINT.AssignVehicle.assignVehicleApi}?${businessType}=true`
  const res = await requestInstance.get(
    url
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}
export const updateAssignVehicleApi = async (data) => {
  const res = await requestInstance.put(
    `${env}${API_ENDPOINT.AssignVehicle.assignVehicleApi}?${businessType}=true`,
    data
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}
export const updateAssignDriverApi = async (data) => {
  const res = await requestInstance.put(
    `${env}${API_ENDPOINT.AssignVehicle.assignDriverApi}?${businessType}=true`,
    data
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}
export const updateAssignSubVendorApi = async (data) => {
  const res = await requestInstance.put(
    `${env}${API_ENDPOINT.AssignVehicle.assignSubVendorApi}?${businessType}=true`,
    data
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}